import { useFilterTracking } from '@backmarket/nuxt-layer-recommendation/filtering/useFilterTracking'

import type { FinderOption } from './useFinder.types'

type FinderInteractionPayload = {
  value: string
  position?: number
}

export function useFinderTracking() {
  const { trackFilterClick } = useFilterTracking()

  function trackFinderInteraction(payload: FinderInteractionPayload) {
    trackFilterClick({ zone: 'filter', name: 'Finder', ...payload })
  }

  function trackSecondaryFinderInteraction(payload: FinderInteractionPayload) {
    trackFilterClick({
      zone: 'filter',
      name: 'Secondary Finder Filters',
      ...payload,
    })
  }

  function trackFinderOptionClick(
    options: FinderOption[],
    optionId: string,
  ): void {
    const index = options.findIndex((option) => option.id === optionId)
    const option = options[index]

    if (option) {
      trackFinderInteraction({ value: option.label, position: index + 1 })
    }
  }

  return {
    trackFinderInteraction,
    trackSecondaryFinderInteraction,
    trackFinderOptionClick,
  }
}
